export default "__VITE_ASSET__d912f74a__"